module.exports = __webpack_public_path__ + "img/Instagram_Story_Icon_6@svg.518ba11d.svg";